import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class UploadedorderService {

  httpOptions: any = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',

        // 'Content-Type': undefined,
        'Access-Control-Allow-Origin': ' *'
    })
}

loggedInUser: any;

  constructor(private _http: HttpClient) { 
    this.loggedInUser = this.getLoggedInUser();
  }


  private getLoggedInUser() {
    if (localStorage.getItem('currentUser'))
    return JSON.parse(localStorage.getItem('currentUser'));
    
  }

  handleError(error: Response) {
    console.log(error);
    return Observable.throw(error);
}

  getAllUploadedPrescriptions() {
    let data = {
      "token": this.loggedInUser.token
    }
    let body = JSON.stringify(data);
    return this._http.post(environment.apiURL + '/api/getAllUploadedPrescriptions', body, this.httpOptions)
    .catch(this.handleError);
  }

  getPatientMedicalHistoryByID(patientID){
    let data = {
      "patientid": patientID,
      "token": this.loggedInUser.token
    }
    let body = JSON.stringify(data);
    return this._http.post(environment.apiURL + '/api/getPatientconsultationHistory ', body, this.httpOptions)
    .catch(this.handleError);
  }

  getMedicineList(){
    let data = {
      "token": this.loggedInUser.token
    }
    let body = JSON.stringify(data);
    return this._http.post(environment.apiURL + '/api/getmedicineList', body, this.httpOptions)
    .catch(this.handleError);
  }

  getPrescriptionInputMaster(){
    // var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    let data = {
      "token": this.loggedInUser.token
    }
    let body = JSON.stringify(data);
    return this._http.post(environment.apiURL + '/api/getPrescriptionInputMaster', body, this.httpOptions)
    .catch(this.handleError);
  }

  getDoctorSpecialisationList(){
    let data = {
      "token": this.loggedInUser.token
    }
    let body = JSON.stringify(data);
    return this._http.post(environment.apiURL + '/api/getDoctorspecializationList', body, this.httpOptions)
    .catch(this.handleError);
  }

  getLabTestList(){
    let data = {
      "isrequireddiagonticstest": false,
      "token": this.loggedInUser.token
    }
    let body = JSON.stringify(data);
    return this._http.post(environment.apiURL + '/api/getLaboratoryTest', body, this.httpOptions)
    .catch(this.handleError);
  }
  getDiagosticsTestList(){
    let data = {
      "isrequireddiagonticstest": true,
      "token": this.loggedInUser.token
    }
    let body = JSON.stringify(data);
    return this._http.post(environment.apiURL + '/api/getLaboratoryTest', body, this.httpOptions)
    .catch(this.handleError);
  }
  createPrescriptionAppointment(patientId, recordId){
    let data ={
      "patientid": patientId,
      "token": this.loggedInUser.token,
      "uploadprescriptionid": recordId,
      "empid": this.loggedInUser.userDetail.id
    }
    // console.log(data);
    let body = JSON.stringify(data);
    return this._http.post(environment.apiURL + '/api/CreatePrescriptionAppointment', body, this.httpOptions)
  }
  updateDraft(appointmentId){
    let data = {
      "appointmentid": appointmentId,
      "token": this.loggedInUser.token,
      "isdraft": false
    }
    let body = JSON.stringify(data);
    return this._http.post(environment.apiURL + '/api/updateDraft', body, this.httpOptions)
    .catch(this.handleError);
  }

  addPrescription(visitId, prescriptionForm){
    //const selectedMedicine = prescriptionForm.get('drugName').value;
    let data = {
      "visitid": visitId,
      "token": this.loggedInUser.token,
    "doctorid": this.loggedInUser.userDetail.id,
     "dispenseform": prescriptionForm.dispenseForm,
     "instructions": prescriptionForm.sig,
      //"quantity": "String",
      //"medicineid": selectedMedicine.drugName,
      "drugname": prescriptionForm.drugName.medicinename,
      "medicineid": prescriptionForm.drugName.medicineid,
      "isallowsubstitution": prescriptionForm.allowSubstitution,
      "refill": prescriptionForm.refills,
      "dose": prescriptionForm.dose,
      "pharmacynotes": prescriptionForm.pharmacyNotes,
      "dayssupply": prescriptionForm.daysSupply,
      "sig": prescriptionForm.sig,
      "dispense": prescriptionForm.dispense
    }
    let body = JSON.stringify(data);
    console.log("service data",body);
    return this._http.post(environment.apiURL + '/api/addprescription', body, this.httpOptions)
    .catch(this.handleError);
  }
  addSoapNotes(visitId, soapNotesForm){
    let data = {
      "visitid": visitId,
      "assessment": soapNotesForm.assessment.icdcode + " - " + soapNotesForm.assessment.icdname,
      "subjective": soapNotesForm.subjective,
      "doctorid": this.loggedInUser.userDetail.id,
      "plan": soapNotesForm.plan,
      "token": this.loggedInUser.token,
      "objective": soapNotesForm.objective
    }
    let body = JSON.stringify(data);
    return this._http.post(environment.apiURL + '/api/addNotes', body, this.httpOptions)
    .catch(this.handleError);

  }
  addLabTest(visitId, labTestForm){
    let data = {
      "token": this.loggedInUser.token,
      "visitid": visitId,
      "descriptionlabtest": labTestForm.labTestNotes,
      "labtestlist": labTestForm.selectedLabTests,

    }
    let body = JSON.stringify(data);
    return this._http.post(environment.apiURL + '/api/addRequisition', body, this.httpOptions)
    .catch(this.handleError);
  }
  addDiagnosticTest(visitId, diagnosticTestForm){
    let data = {
      "token": this.loggedInUser.token,
      "visitid": visitId,
      "descriptiondiagnostictest": diagnosticTestForm.diagnosticTestNotes,
      "diagnostictestlist": diagnosticTestForm.selectedDiagnosticTests
    }
    let body = JSON.stringify(data);
    return this._http.post(environment.apiURL + '/api/addRequisition', body, this.httpOptions)
    .catch(this.handleError);
  }

  getAllIcdCodes(){
    let data = {
      "token": this.loggedInUser.token
    }
    let body = JSON.stringify(data);
    return this._http.post(environment.apiURL + '/api/getAllIcdCodes', body, this.httpOptions)
    .catch(this.handleError);
  }
}




// WEBPACK FOOTER //
// ./src/app/services/uploadedorder.service.ts